import { ReactNode, useState } from "react";
import { Menu } from "lucide-react";

import { PartnerCapabilities } from "../capabilities";
import { SectionKey } from "../sections";
import PartnerSidebar from "../PartnerSidebar";
import {
  Shell,
  Main,
  TopBar,
  TopLeft,
  Hamburger,
  Titles,
  Title,
  Subtitle,
  TopRight,
} from "./styles";

interface PartnerLayoutProps {
  active: SectionKey;
  onSelect: (key: SectionKey) => void;
  capabilities: PartnerCapabilities;
  multiLocation: boolean;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
}

const COLLAPSED_KEY = "jr.partnerSidebarCollapsed";

const readCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
};

const PartnerLayout = ({
  active,
  onSelect,
  capabilities,
  multiLocation,
  title,
  subtitle,
  actions,
  children,
}: PartnerLayoutProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(readCollapsed);

  const toggleCollapsed = () => {
    setCollapsed((c) => {
      try {
        localStorage.setItem(COLLAPSED_KEY, c ? "0" : "1");
      } catch {}
      return !c;
    });
  };

  return (
    <Shell>
      <PartnerSidebar
        active={active}
        onSelect={onSelect}
        capabilities={capabilities}
        multiLocation={multiLocation}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        collapsed={collapsed}
        onToggleCollapsed={toggleCollapsed}
      />

      <Main $collapsed={collapsed}>
        <TopBar>
          <TopLeft>
            <Hamburger
              onClick={() => setDrawerOpen(true)}
              aria-label="Open navigation"
            >
              <Menu size={20} />
            </Hamburger>
            <Titles>
              <Title>{title}</Title>
              {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </Titles>
          </TopLeft>
          {actions && <TopRight>{actions}</TopRight>}
        </TopBar>

        {children}
      </Main>
    </Shell>
  );
};

export default PartnerLayout;
